import { NgModuleRef, Injectable } from '@angular/core';

import { ModalService } from '@bayclubs/utils';

import { GlobalEventsService } from 'src/app/infrastructure/infrastructure.module';
import { OnAddEditGroupClass } from 'src/app/infrastructure/services/events/on-add-edit-group-class';
import { GroupClassSaveComponent } from '../../components/group-class-save/group-class-save.component';

@Injectable({
    providedIn: 'root'
})
export class OnAddEditGroupClassEventHandler {
    constructor(
        private globalEvents: GlobalEventsService,
        private modalService: ModalService,
        private moduleRef: NgModuleRef<any>
    ) {}

    public init(): void {
        this.globalEvents.onAddEditGroupClass$.subscribe(data => {
            this.handle(data);
        });
    }

    public handle(event: OnAddEditGroupClass) {
        var params = {
            id: event.id
        };

        this.modalService.create<GroupClassSaveComponent>(GroupClassSaveComponent, params, this.moduleRef).subscribe(() => {});
    }
}
